export default __webpack_public_path__ + "static/media/fr.b377e778.svg";